<template>
  <!--页面加载动画-->
  <div class="items timeValidity">
    <div class="items-wrap">
      <span class="lables">{{selectData.elementName}}</span>
      <div class="from-right">
        <span :class="[{active:isLong==1},'lz-drop-check']" @click="check(1)">短期</span>
        <span :class="[{active:isLong==2},'lz-drop-check']" @click="check(2)">长期</span>
      </div>
    </div>
    <div class="date-wrap">
      <span class="startDay" v-if="showStartDay" @click="showStart=true">{{start?start:"起始日期"}}</span>
      <span class="surry" v-show="isLong==1 && (showStartDay && showEndDay)">——</span>
      <span class="endDay" v-show="isLong==1 && showEndDay" @click="showEnd=true">{{end?end:"终止日期"}}</span>
    </div>
    <van-popup v-model="showStart" position="bottom">
      <van-datetime-picker
        type="date"
        :min-date="startDate"
        :max-date="nowDate"
        @confirm="dateConfirm($event,1)"
        @cancel="showStart=false"
        :formatter="formatter"
      />
    </van-popup>
    <van-popup v-model="showEnd" position="bottom">
      <van-datetime-picker
        type="date"
        :min-date="tomorrowDate"
        :max-date="endDate"
        @confirm="dateConfirm($event,2)"
        @cancel="showEnd=false"
        :formatter="formatter"
      />
    </van-popup>
  </div>
</template>

<script>
var timor;
import dayjs from "dayjs"
export default {
  data() {
    return {
      showStartDay:false,//是否显示开始时间
      showEndDay:true,//是否显示结束时间
      showStart: false, //显示弹窗
      showEnd: false, //显示弹窗
      isLong: 1, //1-短期，2-长期
      start: "", //起始时间
      end: "", //终止时间
      timeData: [],
      startDate: new Date("1949-01-01"),
      endDate: new Date("2050-12-12"),
      nowDate: new Date(),
      tomorrowDate: "",
    };
  },
  props: ["selectData"],
  mounted() {
    let value = this.selectData.elementValue;
    this.showStartDay=this.selectData.showStart?true:false;
    this.showEndDay=this.selectData.hideEnd?false:true;
    let tomorrow=dayjs().add(1, 'day').format();
    this.tomorrowDate=new Date(tomorrow)
    if (value) {
      this.isLong = value.isLong||1;
      this.start = value.start;
      this.end = value.end;
    }
    this.startDate = this.selectData.beginDate
      ? new Date(this.selectData.beginDate)
      : new Date("1949-01-01");
    this.endDate = this.selectData.endDate
      ? new Date(this.selectData.endDate)
      : new Date("2025-12-12");
  },
  methods: {
    check(i) {
      //按钮选择
      this.isLong = i;
      this.canResult();
    },
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      } else if (type === "day") {
        return `${val}日`;
      }
      return val;
    },
    dateConfirm(t, d) {
      console.log(t);
      console.log(d);
      let time = this.formatDate(t);
      if (d == 1) {
        this.start = time;
        this.showStart = false;
      } else if (d == 2) {
        this.end = time;
        this.showEnd = false;
      }
      this.canResult();
    },
    canResult() {
      if (this.isLong == 1) {
        if (this.showStartDay && this.showEndDay && this.start && this.end) {
          this.getResult();
        }else if (this.showStartDay && !this.showEndDay && this.start) {
          this.getResult();
        }else if (this.showEndDay && this.end) {
          this.getResult();
        }else{
          this.clearVal()
        }
      } else if (this.isLong == 2) {
        if (this.start && this.showStartDay) {
          this.getResult();
        }else if(!this.showStartDay){
          this.getResult();
        }
      }
    },
    getResult() {
      //选择后回调到父组件
      let value = {
        isLong: this.isLong,
        start: this.start,
        end: this.isLong == 1 ? this.end : ""
      };
      this.selectData.elementValue = value;
      this.$emit("selected", {
        type: 1,
        item: this.selectData,
        value: value
      });
    },
    clearVal(){
      this.selectData.elementValue=null
    },

    formatDate(secs) {
      var t = new Date(secs);
      var year = t.getFullYear();
      var month = t.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var date = t.getDate();
      if (date < 10) {
        date = "0" + date;
      }
      var hour = t.getHours();
      if (hour < 10) {
        hour = "0" + hour;
      }
      var minute = t.getMinutes();
      if (minute < 10) {
        minute = "0" + minute;
      }
      var second = t.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      return year + "-" + month + "-" + date;
    }
  }
};
</script>

<style lang="scss" scoped>
.timeValidity {
  .lz-drop-check {
    text-align: center;
    cursor: pointer;
    min-width: 130px;
    height: 100%;
    font-size: 30px;
    line-height: 54px;
    box-shadow: 0 0 3px 0 rgba(0, 132, 255, 0.5);
    padding: 0 15px;
    color: #666;
    display: inline-block;
    margin: 5px 8px 5px 0;
    background-color: #fff;
    border-radius: 60px;
    &.active {
      color: #fff;
      background-color: #0084ff;
    }
  }
  .date-wrap {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 15px 0;
  }
  .startDay,
  .endDay {
    width: 40%;
    height: 60px;
    line-height: 60px;
    text-align: center;
    background-color: #f8f8f8;
    color: #666;
    border-radius: 60px;
  }
  .surry {
    width: 20%;
    text-align: center;
  }
}
</style>